import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { getRole } from '../../../utils/roleUtils';
import { RevGenSummary } from './RevGenSummary';
import { useGetRevGenCoachingGoalQuery } from './revGenSlice';

import { RevgenExpandedGridProps } from './type';
import { selectIsPseudoSupervisor } from '../../../pages/login/authSlice';

export const RevgenExpandedGrid = ({
    loggedEmpNum,
    selectedEmployee,
    inputYear,
    inputMonth,
    userManagerLevel,
    goalRecipient
}: RevgenExpandedGridProps) => {
    const [revGenExpandedList, setRevGenExpandedList] = useState<any[]>([]);
    const [showRevGenGoalSummary, setShowRevGenGoalSummary] = useState<boolean>(false);
    const [recipentDetails, setRecipientDetails] = useState<any>('');
    const isPseudoSupervisor=useSelector(selectIsPseudoSupervisor);

    const { data: myteamgoals } = useGetRevGenCoachingGoalQuery(
        {
            authorId: loggedEmpNum,
            recipientId: selectedEmployee,
            year: inputYear,
            month: inputMonth,
            teamOption: 'expand',
            role: getRole(userManagerLevel,isPseudoSupervisor),
        },
        {
            skip: !loggedEmpNum || !inputYear || !inputMonth || !selectedEmployee,
        }
    );

    useEffect(() => {
        if (myteamgoals?.data?.length > 0) {
            setRevGenExpandedList(myteamgoals.data);
            if(goalRecipient){
                const selectedRec = myteamgoals?.data?.find(
                    (record: any) => record.employee_number === String(goalRecipient)
                );
                if(selectedRec){
                setRecipientDetails(selectedRec);
                            showDialog();
                }
            }
        }
    }, [myteamgoals]);

    const showDialog = () => {
        setShowRevGenGoalSummary(true);
    };

    const createdBtnTemplate = (rowData: any, columnName: string) => {
        const color = rowData[columnName] ? '#2AA154' : '#3F5765';
        return (
            <div style={{ textAlign: 'center' }}>
                <div>
                    <Button
                        type="button"
                        icon={rowData[columnName] ? 'pi pi-pencil' : 'pi pi-plus'}
                        style={{
                            background: 'transparent',
                            border: `${color} 1px solid`,
                            color: `${color}`,
                            width: '30px',
                            height: '30px',
                        }}
                        onClick={() => {
                            setRecipientDetails(rowData);
                            showDialog();
                        }}
                    />
                </div>
            </div>
        );
    };
    const reviewedBtnTemplate = (rowData: any) => {
        return (
            <div style={{ textAlign: 'center' }}>
                <div>
                    <Checkbox className="checkbox-style" checked={rowData.supervisor_discussed} />
                </div>
            </div>
        );
    };
    const acknowledgeBtnTemplate = (rowData: any) => {
        return (
            <div style={{ textAlign: 'center', paddingLeft: '10px' }}>
                <div>
                    <Checkbox className="checkbox-style" checked={rowData.associate_acknowledged} />
                </div>
            </div>
        );
    };
    const monthReviewedBtnTemplate = (rowData: any) => {
        return (
            <div style={{ textAlign: 'center', paddingLeft: '25px' }}>
                <div>
                    <Checkbox className="checkbox-style" checked={rowData.month_end_reviewed} />
                </div>
            </div>
        );
    };

    const closeDialog = (res: boolean) => {
        setShowRevGenGoalSummary(!res);
    };

    return (
        <div>
            <DataTable
                value={revGenExpandedList}
                id="revgen-subgrid"
                rows={5}
                paginator={revGenExpandedList?.length > 5}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 25, 50]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                emptyMessage="No records found."
                showGridlines={false}
                stripedRows
            >
                <Column field="employee_name" style={{ width: '12rem' }} />
                <Column
                    field="goals_created"
                    style={{ width: '5rem' }}
                    body={(rowData: any) => createdBtnTemplate(rowData, 'goals_created')}
                />
                <Column
                    field="supervisor_discussed"
                    style={{ width: '5rem' }}
                    body={(rowData: any) => reviewedBtnTemplate(rowData)}
                />
                <Column
                    field="associate_acknowledged"
                    style={{ width: '5rem' }}
                    body={(rowData: any) => acknowledgeBtnTemplate(rowData)}
                />
                <Column
                    field="month_end_reviewed"
                    style={{ width: '5rem' }}
                    body={(rowData: any) => monthReviewedBtnTemplate(rowData)}
                />
                <Column style={{ width: '1rem' }} />
            </DataTable>
            {showRevGenGoalSummary && (
                <RevGenSummary
                    recipientDetails={recipentDetails}
                    inputMonth={inputMonth}
                    inputYear={inputYear}
                    visible={showRevGenGoalSummary}
                    closeDialog={closeDialog}
                    revgenList={revGenExpandedList}
                />
            )}
        </div>
    );
};
